import {useEffect, useState} from "react";
import { Box } from "@mui/material";
import { UseFormReturn } from "react-hook-form";
import CustomRadioGroup from "@/components/RHFcomponents/CustomRadioGroup";
import { Typography } from "@mui/material"
import CheckboxInput from "@/components/RHFcomponents/CheckboxInput";
import CheckBoxStep from "@/components/Checkout/GuestCheckout/steps/CheckBoxStep.tsx";

interface IProp {
    methods: UseFormReturn<ICheckoutForm, unknown, undefined>;
    paymentMethods?: any;
}

const FormPayStep: React.FC<IProp> = ({paymentMethods, methods: { control, watch } }) => {
    const [checkboxInput, setCheckboxInput] = useState(true);
    const isUSAselected = watch().billingIdCountry === 1;
    const billingAddressValue = watch("billingAddress");

    useEffect(() => {
        setCheckboxInput(billingAddressValue);
    }, [billingAddressValue]);

    return (
        <Box display="flex" gap={{ xs: 2, md: 3 }} flexDirection="column">
            <Typography component="span" style={{ fontSize: '20px', color: '#282828', fontWeight: 700, lineHeight: 1.5,  }}>Chose your payment method</Typography>
            <CustomRadioGroup
                idValidPay
                name="paymentMethodId"
                control={control}
                options={paymentMethods}
            />
            <CheckBoxStep
                checkboxInput={checkboxInput}
                isUSAselected={isUSAselected}
                control={control}
            />
            {(!paymentMethods || paymentMethods.length === 0) && (
                <CheckboxInput
                checked={checkboxInput}
                name="billingAddress"
                control={control}
                label="Use shipping address as billing address"
                onChange={setCheckboxInput}
            />
            )}
        </Box>
    );
};

export default FormPayStep;
